import { render, staticRenderFns } from "./GoalRadialCard.vue?vue&type=template&id=10bd5184&scoped=true"
import script from "./GoalRadialCard.vue?vue&type=script&lang=ts"
export * from "./GoalRadialCard.vue?vue&type=script&lang=ts"
import style0 from "./GoalRadialCard.vue?vue&type=style&index=0&id=10bd5184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd5184",
  null
  
)

export default component.exports